// src/index.tsx

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// IMPORTANT: Global setup for GSAP ScrollTrigger (requires importing/registering)
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

// Note: Create a Global.css or similar file for baseline styles
// import './css/Global.css'; 

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);